<div id="pageCloseBtn" *ngIf="userType != 4">
  <span  (click)="close()">×</span>
</div>
<div id="space"></div>
<!--内部手动审核-->
<div class="fontSize16 lineHeight34" *ngIf="submitType === 1 && !specialUser" id="word1">
  <p>
    <font size="5rem">您的账户还未开通<br />
      请检查手机号</font><br /><br />
    如有问题请联系客服小跃
    <!--点击“开始学习”即可体验-->
    <!--返回公众号菜单<br />-->
    <!--点击“开始学习”即可体验<br />-->
    <!--如有任何疑问<br />-->
    <!--请联系下方客服小跃-->
  </p>
</div>

<!--内部自动审核-->
<div class="fontSize16 lineHeight34"  *ngIf="submitType === 2 && !specialUser" id="word2">
  <p>
    <font size="5rem">您的账户还未开通<br />
    请检查手机号</font><br /><br />
    如有问题请联系客服小跃
    <!--点击“开始学习”即可体验-->
    <!--返回公众号菜单<br />-->
    <!--点击“开始学习”即可体验<br />-->
    <!--如有任何疑问<br />-->
    <!--请联系下方客服小跃-->
  </p>
</div>

<!--外部手动审核-->
<div class="fontSize16 lineHeight34"  *ngIf="specialUser && submitType === 1" id="word3">
  <p>
    <font size="5rem">您的账户还未开通<br />
      请检查手机号</font><br /><br />
    如有问题请联系客服小跃
    <!--点击“开始学习”即可体验-->
    <!--返回公众号菜单<br />-->
    <!--点击“开始学习”即可体验<br />-->
    <!--如有任何疑问<br />-->
    <!--请联系下方客服小跃-->
  </p>
</div>

<!--外部自动审核-->
<div class="fontSize16 lineHeight34"  *ngIf="specialUser && submitType === 2" id="word4">
  <p>
    <font size="5rem">您的账户还未开通<br />
      请检查手机号</font><br /><br />
    如有问题请联系客服小跃
    <!--点击“开始学习”即可体验-->
    <!--返回公众号菜单<br />-->
    <!--点击“开始学习”即可体验<br />-->
    <!--如有任何疑问<br />-->
    <!--请联系下方客服小跃-->
  </p>
</div>

<!--<div class="fontSize18 lineHeight24" id="word2">
  <p>
    专人客服在此<br/>
    如有疑问请扫码
  </p>
</div>-->

<div id="QRcode" *ngIf="!specialUser || (submitType === 1 && specialUser)">
  <img src="/assets/picture/activity/QRcode_2.jpg" />
</div>

<div id="QRcode2" *ngIf="submitType === 2 && specialUser">
  <img src="../../assets/picture/activity/QRCode2.jpg" />
</div>

<div class="bottomBtn" *ngIf="!specialUser &&submitType ===2 " (click)="close()">开始体验完整版“辅导”</div>



// WEBPACK FOOTER //
// ./src/app/activity-success/activity-success.component.html